import { Action } from '../core/Action';

const MY_BOOKED_EVENTS = { entity: 'MY_BOOKED_EVENTS', action: Action.GET };

export { MY_BOOKED_EVENTS };
